export const MAX_COLUMN_WIDTH = 580

export const MIN_COLUMN_WIDTH = 420

export const COLUMN_SEPARATOR_WIDTH = 48

export const MAX_MAIN_WIDTH = MAX_COLUMN_WIDTH * 2 + COLUMN_SEPARATOR_WIDTH

export const EXTRA_SPACE_FOR_FLOATING_SAVE = 60

export const MIN_MAIN_WIDTH = MIN_COLUMN_WIDTH * 2 + COLUMN_SEPARATOR_WIDTH
